import {
  Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges
} from '@angular/core';
import SearchResponse from '../../../response/search.response';
import {Router} from '@angular/router';
import storage from 'store';

@Component({
  selector: 'app-filter-table',
  templateUrl: './filter-table.component.html',
  styleUrls: ['./filter-table.component.scss']
})
export class FilterTableComponent implements OnInit, OnChanges {

  @Input() public column: any;

  @Input() public searchRes: SearchResponse | null;

  @Input() public initFilters: any;

  @Input() public hideClearColumn: any;

  @Output() public filterChange: EventEmitter<any> = new EventEmitter();

  public user = storage.get('user');

  public filters = {};

  constructor(private router: Router) {}

  public clearFilter() {
    for (const name in this.filters) {
      if (this.filters.hasOwnProperty(name) && this.filters[name]) {
        this.filters = {};
        this.dispatchChange();
        break;
      }
    }
  }

  public changeFilter(event) {
    if (event) {
      const val = event.value;
      const name = event.name;

      if (
        val &&
        typeof val === 'object' &&
        !Array.isArray(val) &&
        Array.isArray(val.defined) &&
        typeof val.values === 'string'
      ) {
        const empty =
          val.defined.length === 0 && !String(val.values).trim();
        if (empty) {
          if (this.filters[name]) {
            delete this.filters[name];
          }
        } else {
          this.filters[name] = JSON.stringify(val);
        }
      } else if (typeof val === 'object' && val !== null && Object.keys(val).length === 0) {
        if (this.filters[name]) {
          delete this.filters[name];
        }
      } else if (Array.isArray(val)) {
        this.filters[name] = JSON.stringify(val.map(v => v.value));
      }
    }
    this.dispatchChange();
  }

  private dispatchChange() {
    const event = {};

    for (const name in this.filters) {
      if (this.filters.hasOwnProperty(name) && this.filters[name]) {
        event[name] = this.filters[name];
      }
    }

    this.filterChange.emit(event);
  }

  public clearModels() {
    for (const name in this.filters) {
      if (this.filters.hasOwnProperty(name) && this.filters[name]) {
        this.filters[name] = null;
      }
    }
  }

  ngOnInit() {
    this.filters = {};
    // this.initFilters = {};

    if (this.initFilters) {
      this.filters = Object.assign(this.filters, this.initFilters);
      // for (const name in this.initFilters) {
      //     if (this.initFilters.hasOwnProperty(name)) {
      //         this.filters[name] = this.initFilters[name];
      //     }
      // }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.initFilters && !changes.initFilters.firstChange) {

      this.filters = Object.assign({}, this.initFilters);

    }
  }
}



